import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: "'Poppins', sans-serif",
    h1: { fontFamily: "'Rajdhani', sans-serif" },
    h2: { fontFamily: "'Rajdhani', sans-serif" },
    h3: { fontFamily: "'Rajdhani', sans-serif" },
    h4: { fontFamily: "'Rajdhani', sans-serif" },
    h5: { fontFamily: "'Rajdhani', sans-serif" },
    h6: { fontFamily: "'Rajdhani', sans-serif" },
    button: { fontFamily: "'Rajdhani', sans-serif", fontWeight: 700 },
  },
  palette: {
    mode: "dark",
    primary: {
      main: "#B8EE3C",
    },
    background: {
      default: "#0D0F0A",
      paper: "#15170F",
    },
    text: {
      primary: "#FFFFFF",
      secondary: "#A8A8A8",
    },
  },
  components: {
    MuiTab: {
      styleOverrides: {
        root: {
          color: "#FFFFFF",
          "&.Mui-selected": {
            color: "#B8EE3C",
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        contained: {
          backgroundColor: "#B8EE3C",
          color: "#0D0F0A",
          "&:hover": {
            backgroundColor: "#A6DB2E",
          },
        },
        outlined: {
          borderColor: "#B8EE3C",
          color: "#B8EE3C",
          "&:hover": {
            borderColor: "#A6DB2E",
            color: "#A6DB2E",
          },
        },
      },
    },
  },
});

export default theme;
